<template>
    <div class="page-content header-clear-medium">
        <div v-if="loading">
            <EnvelopeSekeleton :count="3"/>
        </div>
        <div class="p-2 ms-2" v-else>                       
            <h4>Surat Masuk ({{ surat_masuk.length }})</h4>					
            <EnvelopeItem :data="surat_masuk" kode="SM"/>
            
            <h4>Disposisi {{ disposisi.length }}</h4>
            <EnvelopeItem :data="disposisi" kode="DIS"/>
            
            <h4>Tembusan {{ tembusan.length }}</h4>
            <EnvelopeItem :data="tembusan" kode="CC"/>
        </div>

        <div v-if="!is_installed">        
            <Portal to="offcanvas-modal-bottom" :order="2">
                <div v-show="!is_installed" id="offcanvas-subject-class-delete" data-bs-scroll="false" data-bs-backdrop="false" style="visibility: visible;" class="offcanvas offcanvas-bottom rounded-m offcanvas-detached show">
                    <div class="bg-yellow-dark px-3 py-3">
                        <div class="d-flex mt-1">
                            <div class="align-self-center">
                                <h1 class="font-800 color-white mb-0">Pemberitahuan</h1>
                            </div>
                        </div>
                        <p class="color-white opacity-80 pt-2">
                            Surat Belum di Install atau di Aktifkan
                        </p>
                        <router-link :to="{ name: 'home' }" class="default-link btn btn-full btn-s bg-white color-black">Oke, Paham!</router-link>
                    </div>
                </div>
                <div v-show="!is_installed" class="offcanvas-backdrop fade show"></div>
            </Portal>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import EnvelopeSekeleton from "../components/skeleton/EnvelopeSekeleton.vue";
import EnvelopeItem from "../components/partials/EnvelopeItem.vue";

export default {
    name: 'EnvelopeIndex',
    components: {
        EnvelopeSekeleton,
        EnvelopeItem
    },
    data() {
        return {
            showModalPluginExist : false,
        }
    },
    async created() {
        this.SET_LOADING();
        await this.getSuratMasuk({unread: false});
        await this.getDisposisi({unread: false});
        await this.getTembusan({unread: false});
		this.CLEAR_LOADING();
    },
    methods: {
        ...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
        ...mapActions('envelope', ['getSuratMasuk', 'getDisposisi', 'getTembusan']),
    },
    computed: {
        ...mapState({
            loading: state => state.loading
        }),
        ...mapState('envelope', {
            surat_masuk: state => state.surat_masuk,
            disposisi: state => state.disposisi,
            tembusan: state => state.tembusan,
            is_installed: state => state.is_installed
        }),
    }
}
</script>


<style scoped>
.body {
    overflow: auto;
}
</style>   